"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import ClinicianApplicationModal from '@/components/common/ClinicianApplicationModal';

export default function ForCliniciansClient() {
  const [clinicianModalOpen, setClinicianModalOpen] = useState(false);

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-[#f8faf9] via-white to-[#f0f4f2]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#26342f] mb-6">Ready to find your next role?</h2>
          <p className="text-base sm:text-lg md:text-xl text-[#3a4d46] mb-10">Apply in 2 minutes. We'll call within 24 hours.</p>
          <button
            onClick={() => setClinicianModalOpen(true)}
            className="group inline-flex items-center px-10 py-5 text-lg font-semibold text-white bg-gradient-to-r from-[#26342f] to-[#3a4d46] rounded-2xl transition-all duration-300 hover:shadow-[0_0_40px_rgba(93,211,158,0.4)] hover:-translate-y-1"
          >
            Apply now
            <Icon name="ArrowRightIcon" size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </div>
      </section>

      <ClinicianApplicationModal isOpen={clinicianModalOpen} onClose={() => setClinicianModalOpen(false)} />
    </>
  );
}